import { Card } from "primereact/card";
import { classNames } from "primereact/utils";

export function formatDetailValue(key, value) {
    if (value === null || value === undefined || value === "") return "—";
    const isLikelyDate =
        typeof value === "string" &&
        (key.endsWith("_at") ||
            key.endsWith("_on") ||
            key.endsWith("_stamp") ||
            key === "created_at" ||
            key === "created_on" ||
            key === "updated_at");
    if (isLikelyDate) {
        const d = new Date(value);
        if (!Number.isNaN(d.getTime())) {
            return d.toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
        }
    }
    return String(value);
}

export function humanizeKey(key, labelMap) {
    if (labelMap && labelMap[key]) return labelMap[key];
    return key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

/** Renders a flat object as label/value tiles (vehicle, bank, ride core, etc.). */
export function DetailRecordCard({
    title = "",
    iconClass,
    data,
    labelMap,
    preferredOrder,
    skipKeys = ["id", "user_id"],
}) {
    if (!data || typeof data !== "object") return null;
    const preferred = preferredOrder || [];
    const skip = new Set(skipKeys);
    const ordered = [
        ...preferred.filter(
            (k) => Object.prototype.hasOwnProperty.call(data, k) && data[k] !== undefined && !skip.has(k),
        ),
        ...Object.keys(data)
            .filter((k) => !preferred.includes(k) && !skip.has(k))
            .sort(),
    ];
    if (!ordered.length) return null;

    /** Panel sections pass no title/icon — only the field grid (parent supplies the heading). */
    const standalone = Boolean(String(title || "").trim() || iconClass);

    const grid = (
        <div className="grid gap-2">
            {ordered.map((key) => (
                <div key={key} className="col-12 sm:col-6 lg:col-4">
                    <div className="surface-100 border-round-lg p-2 h-full border-1 surface-border flex flex-column">
                        <div className="text-600 text-xs font-medium uppercase letter-spacing-1 mb-1">
                            {humanizeKey(key, labelMap)}
                        </div>
                        <div
                            className="text-900 text-sm line-height-2"
                            style={{ wordBreak: "break-word", overflowWrap: "anywhere" }}
                        >
                            {formatDetailValue(key, data[key])}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );

    if (!standalone) {
        return <div className="surface-ground p-2 border-round-bottom-lg">{grid}</div>;
    }

    const cardHeader = (
        <div className="flex align-items-center gap-2 px-1 py-1">
            {iconClass ? <i className={classNames(iconClass, "text-primary text-base")} aria-hidden /> : null}
            <span className="font-semibold text-900 text-base">{title}</span>
        </div>
    );

    return (
        <Card
            header={cardHeader}
            className={classNames(
                "uc-admin-section-card",
                "shadow-1",
                "border-round-lg",
                "border-1",
                "surface-border",
                "overflow-hidden",
                "m-0",
            )}
            pt={{
                body: { className: classNames("p-0") },
                content: { className: classNames("p-2") },
            }}
        >
            {grid}
        </Card>
    );
}
